import React, { useMemo, useState } from 'react';
import { useToast, Card, Paragraph } from '@leafwell/components';
import type { StudiesByYearChartProps } from './studies-year-chart';

import { useStudiesByYearQuery } from 'graphql/research/types-and-hooks';
import { useWordPressContext } from 'contexts/wordpress-provider';
import { useDasboardContext } from 'contexts/dashboard-context';

import Loader from './loader';
import StudiesByYearChart from './studies-year-chart';

export type StudiesList = StudiesByYearChartProps['studies'];

const DashboardStudiesYear: React.FC<{ id: string }> = ({ id }) => {
  const { addToast } = useToast();
  const { translations } = useWordPressContext();
  const {
    filters,
    initialData: {
      studies: { byYear: initialData },
    },
  } = useDasboardContext();
  const [studies, updateStudies] = useState<StudiesList>(initialData);

  const { loading } = useStudiesByYearQuery({
    skip: !filters,
    variables: { filters },
    onCompleted: data => {
      updateStudies(data.nodes);
    },
    onError: error => {
      addToast({
        content: error.message,
        key: 'dashboard-studies-year-error',
        type: 'negative',
        shouldRemove: true,
      });
    },
  });

  useMemo(() => {
    if (!filters) {
      updateStudies(initialData);
    }
  }, [filters]);

  return (
    <section {...{ id, className: 'grid gap-y-4' }}>
      <Card
        {...{
          rounded: true,
          size: 'large',
          variant: 'secondary',
          className: '!gap-0',
        }}
      >
        <Paragraph size="large" tagName="header">
          {translations['Studies by Year']}
        </Paragraph>
        {loading ? (
          <Loader fullHeight={false} />
        ) : (
          <StudiesByYearChart {...{ studies }} />
        )}
      </Card>
    </section>
  );
};

export default DashboardStudiesYear;
